import { useParams } from 'react-router-dom';

export default function GalleryView() {
  const { id } = useParams<{ id: string }>();

  return (
    <div className="min-h-screen p-8">
      <h1 className="font-display text-4xl font-bold mb-8">Gallery {id}</h1>
      <p className="text-gallery-400">Gallery view coming soon...</p>
    </div>
  );
}
